module.exports = __webpack_public_path__ + "img/guess-number-details3.de163d42.png";